module.exports = "/assets/83f9c8a026d14ca7e5c3969b4ab3714b.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/WJ.png
// module id = 1962
// module chunks = 0